module.exports = __webpack_public_path__ + "media/images/employees-05938732a38888a5eebf34c773e82863.svg";